/* eslint-disable max-len */
import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const Warning: FC<SVGProps> =({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg 
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M8.00033 2.99301L13.0203 11.6663H2.98033L8.00033 2.99301ZM8.00033 0.333008L0.666992 12.9997H15.3337L8.00033 0.333008ZM8.66699 9.66634H7.33366V10.9997H8.66699V9.66634ZM8.66699 5.66634H7.33366V8.33301H8.66699V5.66634Z"
        fill="#F23C34"
      />
    </svg>
  </SvgWrapper>
);
